import { useState } from "react";
import { Link } from "react-router";
import type { ContractRole } from "@talentkontor/domain";
import { api } from "../../../data";
import { date } from "../../../lib/format";
import { ROLE_LABEL } from "./modell";
import { t } from "../../../lib/sprache";

export function signingUrl(token: string): string {
  return `${window.location.origin}/unterschreiben?t=${encodeURIComponent(token)}`;
}

/**
 * Persönliche Links zum Weitergeben (nur in der Demo oder nach „Link manuell teilen“; sonst gehen Links nur per Mail).
 * Sie werden genau einmal angezeigt; gespeichert ist nur ihr Hash.
 */
export function LinkListe({ links, timeZone }: { links: { role: ContractRole; capacity?: "party" | "legal_guardian"; email: string; name?: string; token: string; expires_at: string }[]; timeZone: string }) {
  const [copied, setCopied] = useState<string | null>(null);
  return (
    <div className="tk-signers">
      {links.map((l) => {
        const url = signingUrl(l.token);
        const who = `${ROLE_LABEL[l.role]}${l.capacity === "legal_guardian" ? t(" · gesetzliche Vertretung", " · legal representative") : ""}`;
        return (
          <div key={l.token} className="tk-signer">
            <div className="stack">
              <strong>{who}{l.name ? ` · ${l.name}` : ""}</strong>
              <small>{l.email} {t("· gültig bis ", "· valid until ")}{date(l.expires_at, timeZone)}</small>
              <div className="tk-linkbox">
                <input readOnly value={url} aria-label={t(`Link für ${who}${l.name ? ` ${l.name}` : ""}`, `Link for ${who}${l.name ? ` ${l.name}` : ""}`)} onFocus={(e) => e.currentTarget.select()} />
                <button type="button" onClick={() => { void navigator.clipboard?.writeText(url).then(() => setCopied(l.token)); }}>{copied === l.token ? t("Kopiert", "Copied") : t("Link kopieren", "Copy link")}</button>
              </div>
            </div>
            {/* Demo: im selben Tab öffnen, sonst lädt die Demo-Datenbank neu und der Link ist unbekannt */}
            {api.mode === "demo" && <Link className="btn" to={`/unterschreiben?t=${encodeURIComponent(l.token)}`}>{t("Link öffnen", "Open link")}</Link>}
          </div>
        );
      })}
      <small>{t("Diese Links werden nur jetzt angezeigt. Später erzeugt „Neuen Link senden“ einen neuen.", "These links are only shown now. Later, “Send new link” creates a new one.")}</small>
    </div>
  );
}
